/*
  Created By Muhammad Hassaan
  Date 10 April 2023
*/
import { makeStyles } from "@mui/styles";
import { defaultLabelColors } from "../utils/constants";
import { height } from "@mui/system";
const useStyles = makeStyles((theme: any) => ({
  align_center: {
    display: "flex",
    alignItems: "center",
  },
  display_flex_center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  align_end: {
    display: "flex",
    alignItems: "flex-end",
  },
  justify_center: {
    display: "flex",
    justifyContent: "center",
  },
  justify_end: {
    display: "flex",
    justifyContent: "flex-end",
  },
  direction_row: {
    flexDirection: "row",
  },
  direction_column: {
    flexDirection: "column",
  },
  display_flex_baseline: {
    display: "flex",
    alignItems: "baseline",
  },
  breadcrumb_container: {
    padding: "10px 40px",
    // background: theme.palette.frank.sand,
    boxShadow:
      "0px 2px 4px -1px #00000033, 0px 4px 5px 0px #00000024, 0px 1px 10px 0px #0000001f",
    // position: "fixed",
    // width: "100%",
    marginBottom: 10,
  },
  breadcrumb_head: {
    // color: "#000000" || theme.palette.frank.black,
    fontFamily: "Roboto-Regular",
    fontSize: 34,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
  },
  breadcrumb_time: {
    fontFamily: "Roboto-Medium",
    // color: theme.palette.frank.black,
    fontSize: 24,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
  },
  breadcrumb_description: {
    fontFamily: "Roboto-Regular",
    // color: theme.palette.frank.black,
    fontSize: 18,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
  },
  main_layout_padding: {
    padding: "20px 20px 50px 20px",
  },
  main_layout_padding_2: {
    padding: "20px 100px 50px 100px",
    margin: "20px 100px 50px 100px",
  },
  main_layout_padding_3: {
    padding: "20px 100px 100px 100px",
    margin: "20px 100px 100px 100px",
  },
  colored_input_feild: {
    fontSize: 16,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    // color: theme.palette.frank.appSecondary,
    background: "#fff",
  },
  input_feild: {
    fontSize: 16,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    background: "#fff",
    // color: theme.palette.frank.black,
  },
  info_table: {
    fontSize: 18,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    // color: theme.palette.primary.color_f,
  },
  background_sand: {
    // background: theme.palette.frank.sand,
  },
  background_light_gray: {
    background: "#e0e0e0",
  },
  table_head: {
    fontSize: 16,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    // color: theme.palette.frank.black,
  },
  normal_text: {
    fontSize: 16,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    // color: theme.palette.frank.black,
  },
  simple_normal_text: {
    fontSize: 15,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    // color: theme.palette.frank.black,
  },
  pagination_per_page: {
    padding: 5,
    borderRadius: 4,
    fontSize: 14,
    // color: theme.palette.frank.appSecondary,
    // background: theme.palette.frank.grey1,
    marginRight: 30,
  },
  color_secondary: {
    // color: `${theme.palette.frank.appSecondary} !important`,
  },
  color_primary: {
    // color: `${theme.palette.frank.appPrimary} !important`,
  },
  bg_gray: {
    backgroundColor: "#f6f6f6",
    background: "#f6f6f6",
  },
  primary_divider: {
    // borderColor: theme.palette.frank.appPrimary,
    borderBottomWidth: "medium",
  },
  secondary_divider: {
    // borderColor: theme.palette.frank.appSecondary,
    borderBottomWidth: "medium",
  },
  gray_divider: {
    // borderColor: theme.palette.frank.grey1,
    borderBottomWidth: "medium",
    borderLeftWidth: "medium",
    borderRadius: 10,
  },
  pagination_container: {
    // color: theme.palette.frank.appSecondary,
    "& ul": {
      "& li": {
        "& .Mui-selected": {
          // background: theme.palette.frank.appSecondary,
          // border: `1px solid ${theme.palette.frank.appSecondary}`,
          // color: theme.palette.frank.sand,
          fontFamily: "Roboto-Regular",
          fontSize: 14,
          borderRadius: 3,
          "&:hover": {
            // background: theme.palette.frank.appSecondary,
            // color: theme.palette.frank.sand,
          },
        },
        "& button": {
          // background: theme.palette.frank.grey1,
          // color: theme.palette.frank.appSecondary,
        },
      },
    },
  },
  check_icon: {
    // color: `${theme.palette.frank.appSecondary} !important`,
    height: 24,
    width: 24,
  },
  selected_row: {
    // border: `2px solid ${theme.palette.frank.appSecondary}`,
  },
  unselected_row: {
    borderBottom: `none`,
    borderTop: `2px solid transparent`,
    borderLeft: `2px solid transparent`,
    borderRight: `2px solid transparent`,
  },
  sign_in_type_selected: {
    border: `2px solid #ee6931`,
  },
  sign_in_type_not_selected: {
    border: `2px solid #f4f3f6`,
  },
  input_label_style: {
    padding: "0px 0px 4px 10px",
    fontSize: 16,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    // color: theme.palette.frank.grey3,
  },
  color_red: {
    color: `red !important`,
  },
  button_width: {
    // maxWidth: 150,
    minWidth: 120,
    maxHeight: 43,
    minHeight: 43,
    textTransform: "none",
    boxShadow: "none",
    [theme.breakpoints?.down("sm")]: {
      width: "100%",
      maxWidth: "none",
      minWidth: "0px",
      marginBottom: 5,
    },
  },
  nav_button_width: {
    maxWidth: "200px",
  },
  contained_button: {
    background: defaultLabelColors.main_blue,
    color: defaultLabelColors.white,
    fontFamily: "Raleway-Italic",
    width: "100%",
    borderRadius: "15px",

    "&:hover": {
      background: "#ee6931",
      color: defaultLabelColors.white,
      border: "1px solid #ee6031",
      transition: "1s",
      boxShadow:
        "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    },
  },
  subRiderDocs: {
    width: "100%",
    objectFit: "contain",
    borderRadius: 5,
    height: "100%",
  },
  custom_tab: {
    fontFamily: "Raleway-Variable",
    fontWeight: "700",
    fontSize: "16px",
  },
  disabled_button: {
    background: "#9E9E9E",
    color: "#fff",
    fontFamily: "Epilogue-Medium",
    border: "1px solid #9E9E9E",
    width: "100%",
    "&:hover": {
      background: "#9E9E9E",
      color: defaultLabelColors.main_blue,
      border: "1px solid #9E9E9E",
      transition: "1s",
      boxShadow:
        "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    },
  },
  outlined_button: {
    background: defaultLabelColors.white,
    color: defaultLabelColors.main_blue,
    border: "1px solid #3026f1",
    fontFamily: "Raleway-Italic",
    borderRadius: "12px",

    transition: "1s",
    width: "100%",
    "&:hover": {
      background: defaultLabelColors.white,
      border: "1px solid #ee6031",
      color: defaultLabelColors.main_orange,
      transition: "1s",
      boxShadow:
        "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    },
  },
  delete_button: {
    background: defaultLabelColors.white,
    color: "#D22B2B",
    border: "1px solid #D22B2B",
    transition: "1s",
    fontFamily: "Raleway-Variable",
    borderRadius: "12px",
    width: "100%",
    "&:hover": {
      background: defaultLabelColors.white,
      border: "1px solid #D22B2B",
      color: "#D22B2B",
      transition: "1s",
      boxShadow:
        "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    },
  },
  modal_background: {
    backgroundColor: "#ee6931",
    background: "#ee6931",
    padding: "10px 20px",
    fontFamily: "Epilogue-Medium",
  },

  modal_title: {
    fontSize: 20,
    fontWeight: "700",
    lineHeight: "normal",
    color: defaultLabelColors.main_orange,
    letterSpacing: "0.015em",
    fontFamily: "Raleway-Variable",
  },
  card_label_style: {
    fontSize: 16,
    color: "gray",
    fontFamily: "Roboto-Medium",
  },
  card_value_style: {
    fontSize: 16,
    // color: theme.palette.frank.black,
    fontFamily: "Roboto-Medium",
  },
  profile_name: {
    fontSize: 20,
    // color: theme.palette.frank.black,
    fontFamily: "Roboto-Bold",
    letterSpacing: 1.5,
  },
  active_tab: {
    borderRadius: "5px 5px 0px 0px",
    // color: theme.palette.frank.appSecondary,
    letterSpacing: ": 0.05em",
    fontSize: 18,
    minWidth: 250,
    fontFamily: "RobotoCondensed-Medium",
  },
  inactive_tab: {
    // color: theme.palette.frank.grey3,
    letterSpacing: ": 0.05em",
    fontSize: 18,
    minWidth: 250,
    fontFamily: "RobotoCondensed-Medium",
  },
  accordion_head_container: {
    // backgroundColor: `${theme.palette.frank.sand} !important`,
    // background: `${theme.palette.frank.sand} !important`,
    width: "100%",
    paddingLeft: 15,
    paddingRight: 15,
    borderRadius: "3px 3px 0px 0px ",
    minHeight: `38px !important`,
    height: `38px !important`,
  },
  accordion_heading: {
    fontSize: 20,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "0.015em",
    // color: theme.palette.frank.black,
    fontFamily: "Roboto-Medium",
  },
  accordion_icons: {
    fontSize: 20,
    // color: theme.palette.frank.grey3,
  },
  accordion_container: {
    // border: `1px solid ${theme.palette.frank.sand}`,
  },
  accordion_detail_padding: {
    padding: "24px 32px 30px",
  },
  toggle_sections: {
    // color: theme.palette.frank.appSecondary,
    fontSize: 16,
    paddingLeft: 15,
    fontFamily: "Roboto-Regular",
    cursor: "pointer",
  },
  view_image_text: {
    display: "flex",
    alignItems: "center",
    padding: 10,
    fontFamily: "RobotoCondensed-Regular",
    // color: theme.palette.frank.appSecondary,
  },
  dialog_footer_info: {
    fontSize: 14,
    fontFamily: "RobotoCondensed-Regular",
    // color: theme.palette.frank.grey3,
    width: "max-content",
  },
  dialog_description: {
    fontSize: 16,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    // color: theme.palette.frank.grey3,
    fontFamily: "Roboto-Medium",
  },
  dialog_description_2: {
    fontSize: 16,
    // color: theme.palette.frank.appSecondary,
    fontFamily: "RobotoCondensed-Regular",
  },
  radio_label: {
    fontSize: 16,
    fontFamily: "Roboto-Medium",
    // color: theme.palette.frank.appSecondary,
  },
  unselect_radio_label: {
    fontSize: 16,
    fontFamily: "Roboto-Medium",
    // color: theme.palette.frank.grey3,
  },
  setting_icons: {
    // color: theme.palette.frank.appSecondary,
    height: 60,
    width: "100%",
  },
  setting_container: {
    background: "#ffffff",
    margin: 30,
    padding: 20,
    // border: `2px solid ${theme.palette.frank.appLightPrimary}`,
    borderRadius: 5,

    [theme.breakpoints?.down("sm")]: {
      // margin: 50,
    },
  },
  setting_heading: {
    fontSize: 18,
    fontFamily: "Roboto-Medium",
  },
  setting_description: {
    fontSize: 15,
    fontFamily: "Roboto-Regular",
    // color: theme.palette.frank.grey3,
  },
  setting_hover: {
    transition: "0.5s",
    padding: 10,
    borderRadius: 10,
    "&:hover": {
      // background: theme.palette.frank.sand,
      transition: "0.5s",
    },
  },
  switch_label: {
    fontSize: 16,
    fontFamily: "Roboto-Regular",
    // color: theme.palette.frank.appSecondary,
  },
  rate_dialog_label: {
    fontSize: 16,
    fontFamily: "Roboto-Medium",
    // color: theme.palette.frank.grey3,
  },
  responsive_width: {
    width: "30%",
    [theme.breakpoints?.down("xl")]: {
      width: "50%",
    },
    [theme.breakpoints?.down("lg")]: {
      width: "50%",
    },
    [theme.breakpoints?.down("sm")]: {
      width: "100%",
    },
  },
  commission_label: {
    fontSize: 16,
    // color: theme.palette.frank.grey3,
    fontFamily: "RobotoCondensed-Medium",
  },
  dashboard_card_head: {
    fontSize: 30,
    // color: theme.palette.frank.appSecondary,
    fontFamily: "RobotoCondensed-Medium",
  },
  dashboard_card_title: {
    fontSize: 16,
    // color: theme.palette.frank.appSecondary,
    fontFamily: "Roboto-Medium",
  },
  dashboard_card_container: {
    padding: 10,
    // border: `1px solid ${theme.palette.frank.appSecondary}`,
    borderRadius: 5,
    position: "relative",
    boxShadow: `0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)`,
  },
  sliderImge1: {
    [theme.breakpoints?.down("md")]: {
      display: "none",
    },
    display: "flex",
  },
  contentHeading: {
    fontFamily: "Epilogue-Bold",
    fontSize: "35px",
    display: "flex",
    justifyContent: "center",
    alignItem: "center",
    marginTop: "10px",
  },
  cardHeading: {
    fontFamily: "Epilogue-Medium",
    fontSize: 26,
  },
  loginImage: {
    [theme.breakpoints?.down("md")]: {
      display: "none",
    },
    [theme.breakpoints?.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints?.down("xs")]: {
      display: "none",
    },
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    height: "inherited",
  },
  custom_button: {
    // background: theme.palette.frank.appSecondary,
    borderRadius: 16,
    width: "100%",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#fff",
      // color: theme.palette.frank.appSecondary,
    },
  },
  review_applicaiton_heading: {
    fontFamily: "Epilogue-Medium",
    fontSize: "20px",
    color: "black",
    flex: 1,
    opacity: "70%",
  },
  review_applicaiton_content: {
    fontFamily: "Epilogue-Light",
    fontSize: "18px",
    color: "grey",
    flex: 1,
  },
  button_font_responsive: {
    fontSize: 16,
    "@media (max-width: 390px)": {
      fontSize: 12,
    },
  },
  landing_banner_mobile: {
    height: 804, //md ? 664 : 864,
    objectFit: "contain",

    "@media (max-width: 1545px)": {
      height: 800, //md ? 664 : 864,
    },

    "@media (max-width: 1535px)": {
      height: 750, //md ? 664 : 864,
    },

    "@media (max-width: 1350px)": {
      height: 750, //md ? 664 : 864,
    },
    "@media (max-width: 1200px)": {
      height: 600, //md ? 664 : 864,
      marginTop: 50,
    },
  },
  landing_banner_mobile_tab: {
    height: 440, //md ? 664 : 864,
    objectFit: "contain",

    "@media (max-width: 920)": {
      height: 750, //md ? 664 : 864,
    },
  },

  banner_section_div: {
    maxWidth: "682px",

    "@media (max-width: 1800px)": {
      maxWidth: "600px",
    },
    "@media (max-width: 1700px)": {
      maxWidth: "610px",
    },
    "@media (max-width: 1600px)": {
      maxWidth: "620px",
    },
    "@media (max-width: 1430px)": {
      maxWidth: "630px",
    },
    "@media (max-width: 1366px)": {
      maxWidth: "530px",
    },
    "@media (max-width: 1350px)": {
      maxWidth: "560px",
    },
    "@media (max-width: 1334px)": {
      maxWidth: "515px",
    },
    "@media (max-width: 1280px)": {
      maxWidth: "450px",
    },
    "@media (max-width: 930px)": {
      maxWidth: "420px",
    },
    "@media (max-width: 900px)": {
      maxWidth: "380px",
    },
    "@media (max-width: 850px)": {
      maxWidth: "330px",
    },
    "@media (max-width: 800px)": {
      maxWidth: "290px",
    },
    "@media (max-width: 750px)": {
      maxWidth: "250px",
    },
    "@media (max-width: 690px)": {
      maxWidth: "210px",
    },
    "@media (max-width: 650px)": {
      maxWidth: "180px",
    },
    "@media (max-width: 620px)": {
      maxWidth: "160px",
    },
  },

  ladnding_page_mobile_image: {
    right: -160,
    "@media (max-width: 1600px)": {
      right: -140,
    },
    "@media (max-width: 1700px)": {
      right: -120,
    },
    "@media (max-width: 1800px)": {
      right: -100,
    },
  },

  //
  banner_tablet_div: {
    // width: "900px",
    maxWidth: "550px",
    "@media (min-width: 700px) and (max-width: 741px)": {
      maxWidth: "300px",
    },
    "@media (min-width: 740px) and (max-width: 800px)": {
      maxWidth: "344px",
    },
    "@media (min-width: 801px) and (max-width: 850px)": {
      maxWidth: "380px",
    },
    "@media (min-width: 851px) and (max-width: 900px)": {
      maxWidth: "400px",
    },
    "@media (min-width: 901px) and (max-width: 950px)": {
      maxWidth: "450px",
    },
    "@media (min-width: 951px) and (max-width: 1000px)": {
      maxWidth: "500px",
    },
  },
 

  tab_image_position:{
    right:"-116px",
    bottom:"-5px",
    "@media (min-width: 600px) and (max-width: 700px)": {
      // maxWidth: "500px",
      display:"none",
    },
  },
  banner_tab_image:{
    "@media (min-width: 700px) and (max-width: 600px)": {
      // maxWidth: "500px",
      display:"none",
    },
  }
}));

export default useStyles;
